<div>

  <button ng-if="('task.view'|HasPerm)||('task.offer.view'|HasPerm)" (click)="create()" class="btn btn-default">
    <span class="fa fa-plus"></span>
  </button>

</div>
